import {useEffect, useState} from "react";
import {useErrors} from "../provider";
import styled from "@mui/material/styles/styled";
import Alert from "@mui/material/Alert";

const AlertStyled = styled(Alert)(({theme}) => ({
    marginBottom: theme.spacing(1),
    whiteSpace: "pre-line",
    width: "100%",
    margin: "6px 0",
}));

const ErrorAlertList = ({errors, hideCloseButton = false, ...props}) => {
    const {clearErrors} = useErrors();

    const [visible, setVisible] = useState(errors.length > 0);

    useEffect(() => {
        setVisible(errors.length > 0);
    }, [errors]);

    const handleClose = () => {
        setVisible(false);
        clearErrors(); // TODO(cmartin): not working since we are using locally-handled errors instead of errors from Error Provider.
    };

    const flatErrors = errors.flat();

    if (!visible || flatErrors.length === 0) return null;

    return (
        <AlertStyled
            severity="error"
            onClose={!hideCloseButton ? handleClose : null}
            {...props}
        >
            {flatErrors.map((item, index) => {
                console.log({item});
                return (
                    <div key={index}>
                        {item?.field
                            ? `${item?.field}: ${item?.message || item}`
                            : item?.message || item}
                    </div>
                );
            })}
        </AlertStyled>
    );
};

export default ErrorAlertList;
